<app-user-dashboard [userMenuActiveItemIndex]="0" [activeItem]="'forwarderReviews'">
  <p-tabMenu [model]="tabMenuItems" [scrollable]="true" [activeItem]="activeItem"></p-tabMenu>
  <div style="margin-top: 1em">
    <div class="card">
      <div class="header-card">
        <div class="container-title">
          <h2 class="title-main">{{ 'UserDashboardComponent.UserDashboardMenu.OriginForwarderReviewsLabel' | translate }}</h2>
        </div>
      </div>
      <div class="body-card">
        <!--
          <p class="subtitle">{{ 'ForwarderPage.ForwarderReviewsPending.Title' | translate }}</p>
        -->

        <div class="forwarder-reviews-dataview">
          <p-dataView #dv
            [value]="reviews"
            [rows]="10"
            [paginator]="true"
            [rowsPerPageOptions]="[10, 25, 50]"
            [loading]="loading"
            emptyMessage="{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.EmptyResultsText' | translate}}"
            >
            <ng-template let-review pTemplate="listItem">
              <div class="card" [style]="{'margin-bottom': '20px'}">
                <div class="container-card">

                  <div class="container-row">

                    <div class="row-style">
                      <div class="container-flex-fit">

                        <div class="container-img">
                          <img [src]="getIconUrl(review.varietyUrlIcon) | speciesImageUrl" style="border-radius: 7px; width: 100%; max-width: 50px; min-width: 50px; height: auto;" alt="" *ngIf="review.varietyUrlIcon"/>
                          <span class="material-symbols-outlined" style="font-size:40px;opacity:.3;color:#8C2B87" *ngIf="!review.varietyUrlIcon">
                            no_photography
                          </span>
                        </div>
                        <div class="flex-container container-main-info">
                          <h2 class="text-main"  style="font-size: 14px;">{{review | speciesName}} / {{review.varietyName}}</h2>
                          <span style="font-weight: normal; font-size: 12px;"><strong style="color: #8c2b87">{{'ImportCloseSaleTable.CodeText' | translate}}:</strong> {{review.importOrderSequence}}</span>
                          <span style="font-weight: normal; font-size: 12px;"><strong style="color: #8c2b87">{{'ImportCloseSaleTable.InstructiveText' | translate}}:</strong> {{review.instructive}}</span>
                          <span style="font-weight: normal; font-size: 12px;"><strong style="color: #8c2b87">{{'ImportCloseSaleTable.ContainerText' | translate}}:</strong> {{review.container}}</span>
                        </div>
                      </div>
                    </div>

                    <div class="border-lat"></div>

                      <div class="container-countries flex flex-row">
                        <div class="country-container w-4">
                          <h4 class="title-small">{{ 'ForwarderPage.ForwarderReviewsPending.OriginPort' | translate }}</h4>
                          <div class="flex justify-content-start align-items-center">
                            <img *ngIf="review.departureCountry" [flag]="review.departureCountry?.code" height="40px" alt=""/>
                            <div *ngIf="!review.departureCountry" class="not-country"></div>
                            <div class="flex flex-column" style="margin-left: 10px;">
                              <span *ngIf="review.departureCountry && translate.currentLang === 'en'" style="font-weight: bolder; font-size: small;">{{review.departureCountry?.name}}</span>
                              <span *ngIf="review.departureCountry  && translate.currentLang === 'es'" style="font-weight: bolder; font-size: small;">{{review.departureCountry?.nameEs}}</span>
                              <span style="font-size: small; ">{{review.portFromName}}</span>
                            </div>
                          </div>
                        </div>

                        <div class="container-flex-fit pd-top-arrow flex-column w-4">
                          <div>
                            <span class="material-symbols-outlined" style="color: #6da043;" *ngIf="review.transportType == 0" >directions_boat</span>
                            <span class="material-symbols-outlined" style="color: #6da043;" *ngIf="review.transportType == 1" > flight</span>
                            <span class="material-symbols-outlined" style="color: #6da043;">arrow_forward_ios</span>
                          </div>
                          <div *ngIf="review.ship" class="flex justify-content-center">
                            <span class="text-center" style="font-size: small;">{{ review.ship }}</span>
                          </div>
                        </div>

                        <div class="country-container justify-content-start align-content-start align-items-start w-4">
                          <h4 class="title-small">{{ 'ForwarderPage.ForwarderReviewsPending.DestinationPort' | translate }}</h4>
                          <div class="flex justify-content-start align-items-start">
                            <img *ngIf="review.destinationCountry" [flag]="review.destinationCountry" height="40px" alt=""/>
                            <div *ngIf="!review.destinationCountry" class="not-country"></div>
                            <div class="flex flex-column" style="margin-left: 10px;">
                              <span *ngIf="review.exporter.destinationCountry && translate.currentLang === 'en'" style="font-weight: bolder; font-size: small; ">{{review.destinationCountry.name}}</span>
                              <span *ngIf="review.destinationCountry && translate.currentLang === 'es'" style="font-weight: bolder; font-size: small; ">{{review.destinationCountry.nameEs}}</span>
                              <span style="font-size: small; ">{{review.portToName}}</span>
                            </div>
                          </div>
                        </div>

                      </div>

                    <div class="border-lat"></div>

                    <div class="container-profile">
                      <h4 class="title-small">{{ 'ForwarderPage.ForwarderReviewsPending.ProfileAssigned' | translate }}</h4>
                      <div class="container-flex-small">
                        <div class="container-icon">
                          <span class="pi pi-user"></span>
                        </div>
                        <span style="font-size: small; " *ngIf="review.profileAssigned">{{review.profileAssigned.contactName}} {{review.profileAssigned.contactLastName}}</span>
                        <span style="font-size: small; " *ngIf="!review.profileAssigned">{{ 'ForwarderPage.ForwarderReviewsPending.ProfileStatus' | translate }}</span>

                      </div>
                    </div>

                    <div class="border-lat"></div>

                    <div class="container-flex">
                      <button pButtom class="btn-main" (click)="goToReviewDocuments(review)">{{ 'ForwarderPage.ForwarderReviewsPending.ButtonReview' | translate }}</button>
                      <div class="btn-expand-custom">
                        <p-button
                          [icon]="review.expanded ? 'pi pi-angle-up' : 'pi pi-angle-down'"
                          styleClass="p-button-rounded p-button-outlined "
                          (click)="setVisibleOrderDetail(review)"
                          >
                        </p-button>
                      </div>
                    </div>


                  </div>

                  <div class="container-row">

                    <div *ngIf="review.expanded" class="container-expanded">
                      <div class="column-expanded-left">
                        <div class="container-column">
                          <h4 class="title-column">
                            {{'ForwarderPage.ForwarderReviewsPending.TableDetail.AgreementTitle' | translate}}
                          </h4>

                          <div class="row-info">
                            <i class="pi pi-circle-fill icon-network" style="font-size:4px;color:#8c2c85;"></i>
                            <span class="info-text">
                              <span class="label-color">
                                {{'ForwarderPage.ForwarderReviewsPending.TableDetail.TypeLabel' | translate}}:
                              </span>
                              {{review.productType === "program_order" ? programOrderOption : review.productType === "marketplace_order" ? marketplaceOrderOption : 'No included'}}
                            </span>
                          </div>
                          <div class="row-info">
                            <i class="pi pi-circle-fill icon-network" style="font-size:4px;color:#8c2c85;"></i>
                            <span class="info-text">
                              <span class="label-color">
                                {{'ForwarderPage.ForwarderReviewsPending.TableDetail.ExporterLabel' | translate}}:
                              </span>
                              {{review.exporter ? review.exporter.contactName :
                                'No included'}}
                            </span>
                          </div>
                          <div class="row-info">
                            <i class="pi pi-circle-fill icon-network" style="font-size:4px;color:#8c2c85;"></i>
                            <span class="info-text">
                              <span class="label-color">
                                {{'ForwarderPage.ForwarderReviewsPending.TableDetail.ImporterLabel' | translate}}:
                              </span>
                              {{review.importer ? review.importer.contactName :
                                'No included'}}
                            </span>
                          </div>
                          <div class="row-info">
                            <i class="pi pi-circle-fill icon-network" style="font-size:4px;color:#8c2c85;"></i>
                            <span class="info-text">
                              <span class="label-color">
                                {{'ForwarderPage.ForwarderReviewsPending.TableDetail.ConsigneeLabel' | translate}}:
                              </span>
                              {{review.consignee ? review.consignee :
                                'No included'}}
                            </span>
                          </div>
                          <div class="row-info">
                            <i class="pi pi-circle-fill icon-network" style="font-size:4px;color:#8c2c85;"></i>
                            <span class="info-text">
                              <span class="label-color">
                                {{'ForwarderPage.ForwarderReviewsPending.TableDetail.NotifyLabel' | translate}}:
                              </span>
                              {{review.notify ? review.notify :
                                'No included'}}
                            </span>
                          </div>
                        </div>
                        <div class="container-column">
                          <h4 class="title-column">
                            {{'ForwarderPage.ForwarderReviewsPending.TableDetail.FridgeInfoTitle' | translate}}
                          </h4>
                          <div class="row-info">
                            <i class="pi pi-circle-fill icon-network" style="font-size:4px;color:#8c2c85;"></i>
                            <span class="info-text">
                              <span class="label-color">
                                {{'ForwarderPage.ForwarderReviewsPending.TableDetail.FridgeStorageNameLabel' | translate}}:
                              </span>
                              {{review.fridgeStorageName ? review.fridgeStorageName :
                                'No included'}}
                            </span>
                          </div>
                          <div class="row-info">
                            <i class="pi pi-circle-fill icon-network" style="font-size:4px;color:#8c2c85;"></i>
                            <span class="info-text">
                              <span class="label-color">
                                {{'ForwarderPage.ForwarderReviewsPending.TableDetail.FridgeStorageContactLabel' | translate}}:
                              </span>
                              {{review.fridgeStorageContact ? review.fridgeStorageContact :
                                'No included'}}
                            </span>
                          </div>
                          <div class="row-info">
                            <i class="pi pi-circle-fill icon-network" style="font-size:4px;color:#8c2c85;"></i>
                            <span class="info-text">
                              <span class="label-color">
                                {{'ForwarderPage.ForwarderReviewsPending.TableDetail.FridgeStoragePhoneLabel' | translate}}:
                              </span>
                              {{review.fridgeStoragePhone ? review.fridgeStoragePhone :
                                'No included'}}
                            </span>
                          </div>
                          <div class="row-info">
                            <i class="pi pi-circle-fill icon-network" style="font-size:4px;color:#8c2c85;"></i>
                            <span class="info-text">
                              <span class="label-color">
                                {{'ForwarderPage.ForwarderReviewsPending.TableDetail.FridgeStorageEmailLabel' | translate}}:
                              </span>
                              {{review.fridgeStorageEmail ? review.fridgeStorageEmail :
                                'No included'}}
                            </span>
                          </div>

                          <div class="row-info" *ngIf="translate.currentLang=='en'">
                            <i class="pi pi-circle-fill icon-network" style="font-size:4px;color:#8c2c85;"></i>
                            <span class="info-text">
                              <span class="label-color">
                                {{'ForwarderPage.ForwarderReviewsPending.TableDetail.FridgeStorageCountryLabel' | translate}}:
                              </span>
                              {{review.fridgeStorageCountryName ? review.fridgeStorageCountryName :
                                'No included'}}
                            </span>
                          </div>
                          <div class="row-info" *ngIf="translate.currentLang=='es'">
                            <i class="pi pi-circle-fill icon-network" style="font-size:4px;color:#8c2c85;"></i>
                            <span class="info-text">
                              <span class="label-color">
                                {{'ForwarderPage.ForwarderReviewsPending.TableDetail.FridgeStorageCountryLabel' | translate}}:
                              </span>
                              {{review.fridgeStorageCountryNameEs ? review.fridgeStorageCountryNameEs :
                                'No included'}}
                            </span>
                          </div>
                          <div class="row-info">
                            <i class="pi pi-circle-fill icon-network" style="font-size:4px;color:#8c2c85;"></i>
                            <span class="info-text">
                              <span class="label-color">
                                {{'ForwarderPage.ForwarderReviewsPending.TableDetail.FridgeStorageCityLabel' | translate}}:
                              </span>
                              {{review.fridgeStorageCity ? review.fridgeStorageCity :
                                'No included'}}
                            </span>
                          </div>
                          <div class="row-info">
                            <i class="pi pi-circle-fill icon-network" style="font-size:4px;color:#8c2c85;"></i>
                            <span class="info-text">
                              <span class="label-color">
                                {{'ForwarderPage.ForwarderReviewsPending.TableDetail.FridgeStorageAddressLabel' | translate}}:
                              </span>
                              {{review.fridgeStorageAddress ? review.fridgeStorageAddress :
                                'No included'}}
                            </span>
                          </div>

                        </div>
                        <div class="container-column">
                          <h4 class="title-column ">
                            {{'ForwarderPage.ForwarderReviewsPending.TableDetail.InformationTitle' | translate}}
                          </h4>
                          <div class="row-info" *ngIf="translate.currentLang=='en'">
                            <i class="pi pi-circle-fill icon-network" style="font-size:4px;color:#8c2c85;"></i>
                            <span class="info-text">
                              <span class="label-color">
                                {{'ForwarderPage.ForwarderReviewsPending.TableDetail.FridgeStorageCountryLabel' | translate}}:
                              </span>
                              {{review.fridgeStorageCountryName ? review.fridgeStorageCountryName :
                                'No included'}}
                            </span>
                          </div>
                          <div class="row-info" *ngIf="translate.currentLang=='es'">
                            <i class="pi pi-circle-fill icon-network" style="font-size:4px;color:#8c2c85;"></i>
                            <span class="info-text">
                              <span class="label-color">
                                {{'ForwarderPage.ForwarderReviewsPending.TableDetail.DusLabel' | translate}}:
                              </span>
                              {{review.dus ? review.dus :
                                'No included'}}
                            </span>
                          </div>
                          <div class="row-info">
                            <i class="pi pi-circle-fill icon-network" style="font-size:4px;color:#8c2c85;"></i>
                            <span class="info-text">
                              <span class="label-color">
                                {{'ForwarderPage.ForwarderReviewsPending.TableDetail.BookingLabel' | translate}}:
                              </span>
                              {{review.booking ? review.booking :
                                'No included'}}
                            </span>
                          </div>

                        </div>
                      </div>
                      <div class="column-right">
                        <button pButtom class="btn-pending" *ngIf="profile?.forwardAdmin && !review.profileAssigned" styleClass="p-button-warning" (click)="openDialog(review)">{{ 'ForwarderPage.ForwarderReviewsPending.ButtonAssign' | translate }}</button>
                        <button pButtom class="btn-user-assigned" *ngIf="profile?.forwardAdmin && review.profileAssigned" (click)="openDialog(review)">{{ 'ForwarderPage.ForwarderReviewsPending.ButtonNewAssign' | translate }}</button>

                        <button pButtom class="btn-ghost" (click)="goToDelivery(review)">
                          <i class="pi pi pi-table icon-network"></i>
                          {{ 'ForwarderPage.ForwarderReviewsPending.ButtonPreBL' | translate }}
                        </button>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </ng-template>
          </p-dataView>
        </div>

      </div>
    </div>
  </div>
</app-user-dashboard>

<p-dialog [resizable]="false" [modal]="true" [draggable]="false" [(visible)]="visibleAssignDialog" [style]="{width: '30%'}">
  <ng-template pTemplate="header">
    <h2>{{ 'ForwarderPage.ForwarderReviewsPending.Modal.Title' | translate }}</h2>
  </ng-template>
  <ng-template pTemplate="body">
    <div class="p-fluid formgrid grid">
      <div class="field col-12 xl:col-12 lg:col-12" style="margin-bottom: 40px;">
        <p-dropdown inputId="profileId" [(ngModel)]="selectedForwarderOrder" [options]="forwarders" optionValue="profileId" optionLabel="profile.contactName" placeholder="{{ 'ForwarderPage.ForwarderReviewsPending.Modal.SelectForwarderPlaceholder' | translate }}" [style]="{'minWidth':'100%'}" class="p-inputtext-sm" appendTo="body"></p-dropdown>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <p-button [loading]="loading" label="{{ 'ForwarderPage.ForwarderReviewsPending.Modal.ButtonAssign' | translate }}" (onClick)="assignUser()"/>
  </ng-template>
</p-dialog>


